<template>
  <div>
    <label :for="id" class="block mb-2 font-semibold">
      {{ label }} <span v-if="required" class="text-brand-blue">*</span>
    </label>
    <input
      type="text"
      :id="id"
      :name="id"
      :value="value"
      @input="$emit('input', $event.target.value)"
       @blur="$emit('blur')"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :class="[
        'w-full p-3 bg-white border rounded-xl outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue transition-all',
        error ? 'border-red-500' : 'border-gray-200',
      ]"
    />
    <a
      v-if="helpText"
      class="block mt-1 text-xs text-brand-gray hover:underline"
      @click="helpTextClick"
      >{{ helpText }}</a
    >
    <p v-if="error" class="mt-1 text-xs text-red-500">{{ error }}</p>
  </div>
</template>
<script>
export default {
  props: [
    "value",
    "label",
    "id",
    "placeholder",
    "error",
    "required",
    "helpText",
    "maxlength",
  ],
  methods: {
    helpTextClick() {
      this.$emit("helpTextClick", this.helpText);
    },
  },
};
</script>
